export const AlphaNumericWithSeparators = /^[0-9A-Za-z_-]*$/;

// Card field validation patterns
export const DIGITS_ONLY_PATTERN = /^\d+$/;
export const EXPIRATION_FORMAT_PATTERN = /^\d{2}\/\d{2}$/;
export const DOB_FORMAT_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
export const TRACK1_FORMAT_PATTERN = /^%B[^^]+\^[^^]+\^[^?]+\?$/;
export const TRACK2_FORMAT_PATTERN = /^;[^=]+=[^?]+\?$/;
export const IPV4_FORMAT_PATTERN = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
export const SSN_FORMAT_PATTERN = /^(\d{9}|\d{3}-\d{2}-\d{4})$/;
export const ZIP_FORMAT_PATTERN = /^\d{5}(-\d{4})?$/;
